// ✅ Split name into first/last
export const splitFullName = (full = "") => {
  const parts = String(full).trim().split(/\s+/);
  return { firstName: parts[0] || "", lastName: parts.slice(1).join(" ") || "" };
};

// ✅ Normalize admin/superadmin object
export const normalizeAccount = (a, defaultRole = "admin") => {
  if (!a) return null;

  const _id = a._id ?? a.id;
  if (!_id) return null;

  let firstName = a.firstName ?? "";
  let lastName = a.lastName ?? "";

  if (!firstName && !lastName && a.name) {
    const s = splitFullName(a.name);
    firstName = s.firstName;
    lastName = s.lastName;
  }

  const fullName = `${firstName} ${lastName}`.trim();
  const displayName = firstName || a.username || a.email || fullName || "Admin";

  // Preserve the role from the API response, ensuring it's lowercase
  const role = a.role ? String(a.role).toLowerCase() : defaultRole;

  return {
    ...a,
    _id: String(_id),
    firstName,
    lastName,
    fullName,
    displayName,
    role,
  };
};

export const resolveAccountId = (account) => {
  const id = account?._id ?? account?.id;
  return id ? String(id) : null;
};
